module.exports = __webpack_public_path__ + "static/media/dark_irancell_labz_logo.b1b4f001.svg";